
import Vue, { PropType } from 'vue'
import { Checkbox } from 'vue-checkbox-radio'

export default Vue.extend({
  name: 'BaseSingleCheckbox',

  components: {
    Checkbox
  },

  props: {
    value: Boolean as PropType<boolean>,
    label: String as PropType<string>,
    iconName: String as PropType<string>,
    name: String as PropType<string>,
  },

  computed: {
    bindValue: {
      get (): boolean {
        return this.value
      },

      set (): void {
        this.$emit('input', !this.value)
      }
    }
  },
})
